<template>

  <div class="container">
    <div class="row" style="margin-top: 3%;">
      <div class="col-lg-8 col-md-8 col-12" id="col_cart">
        <a href="#" style="text-decoration: underline;" id="title_page"> {{ $t('Review Order') }}</a>
        <button v-if="this.items.length != 0" class="clear_cart" @click="show = true"><i class="fa fa-trash-o"></i> {{
          $t('Clear Cart') }}</button>
        <table v-if="this.items.length != 0">
          <tr>

            <th>{{ $t('product') }} </th>
            <th></th>
            <th>{{ $t('price') }}</th>
            <th>{{ $t('qnt') }}</th>
            <th>{{ $t('sub total') }}</th>
            <th></th>
          </tr>
          <item_cart v-for="item in this.items" :key="item" :item-id="item"></item_cart>
        </table>

        <div v-else>
          <div class="container">
            <h4 style="text-align: center; text-decoration: 2px underline; text-underline-offset: 3px; margin-top:1%;">
              {{ $t('cartEmpty') }} !!</h4>


            <img v-if="this.items.length == 0" style="width: 50%; margin-left: 25%; margin-right: 25%;    
        filter: hue-rotate(248deg)" src="https://etrolley.net/store/assets/image/emptyCard.gif" />


          </div>
        </div>
        <div v-if="this.items.length != 0" class="d-flex justify-content-between" style="margin-top: 6%;"
          id="botton_postion">
          <button class="btn_cart_check" style="direction: ltr;"><i class="fa fa-angle-left"></i>{{ $t('Continu
            Shopping') }}</button>

          <button v-if="this.$localStorage.get(this.$store.storeName) == null" class="btn_cart_check"
            @click="confirmOrder_guest()"><i class="fa fa-angle-right"></i> {{ $t('Procced to Checkout') }}</button>
          <button v-else class="btn_cart_check" @click="confirmOrder()"><i class="fa fa-angle-right"></i> {{ $t('Procced
            to Checkout') }}</button>

        </div>



      </div>



      <div class="col-lg-4 col-md-4 col-12" id="col_cheakout" v-if="this.items.length != 0">
        <!-- <div class="progress-container">

                    <button class="step d" @click="$router.push({
                        name: 'shoppingCart',
                        params: {
                            storeName: $store.storeName,
                            lang: $i18n.locale
                        },
                    });">

                        {{ $t('Review Order') }}


                    </button>



                    <button class="step "  @click="$router.push({
    name: 'shoppingCart',
    params: {
      storeName: $store.storeName,
      lang: $i18n.locale
    },
  });">
                        {{ $t('address') }}
                    </button>

                    <button class="step active "@click="$router.push({
    name: 'shoppingCart',
    params: {
      storeName: $store.storeName,
      lang: $i18n.locale
    },
  });">
                        {{ $t('Confirm Order') }}
                    </button>

                </div> -->

        <div class="card_checkout">
          <h5 class="title_cart">{{ $t('Order Total') }}</h5>
          <hr id="hr_cart">
          <table class="table mb-0">
            <tbody>
              <tr id="empty">
                <td class="col-md-2 col-3 border-0"></td>
                <td class="col-md-2 col-3 border-0"></td>
              </tr>
              <tr id="order_total_untaxed">
                <td class="text-start border-0" style="padding-bottom: 11px; ">{{ $t('Subtotal') }}:</td>
                <td class="text-xl-end border-0">
                  <span class="monetary_field" style="white-space: nowrap;"><span class="oe_currency_value">{{
                    (price * $store.state.rate).toFixed($store.state.digit_price) }}
                    </span>&nbsp;{{ $store.state.UnitPrice }}</span>
                </td>
              </tr>

              <tr id="order_total">
                <td class="text-start border-top border-bottom-0">
                  <span style="padding-bottom: 30px; padding-left: 15px;">{{ $t('total') }}:</span>
                </td>
                <td class="text-xl-end border-top border-bottom-0">
                  <span class="monetary_field"><span class="oe_currency_value">{{
                    (price * $store.state.rate).toFixed($store.state.digit_price) }}
                    </span>&nbsp;{{ $store.state.UnitPrice }}</span>
                </td>
              </tr>

              <tr class="oe_website_sale_gift_card">
                <td colspan="3" class="text-center text-xl-end border-0">
                  <span class="">
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <div style="direction: rtl; margin-right: 2%;">
            <button v-if="this.$localStorage.get(this.$store.storeName) != null" class="btn_cart_check"
              @click="confirmOrd()"><i class="fa fa-angle-right"></i> {{ $t('Procced to Checkout') }}</button>
            <button v-else class="btn_cart_check" @click="confirmOrder_guest()"><i class="fa fa-angle-right"></i> {{
              $t('Procced to Checkout') }}</button>

          </div>

        </div>


      </div>
    </div>

    <Transition name="modal">
      <div v-if="show" class="modal-mask ">
        <div class="modal-wrapper">
          <div class="modal-container float_card">
            <div class="modal-header">
              <slot name="header">
                <h6 style="width:100%;text-align:center">{{ $t('confirmdeleteAll') }}</h6>
              </slot>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button close" @click="deleteAllCookies()">{{ $t('confirm') }}</button>
                <button class="modal-default-button cancel " @click="(show = false), $emit('close')">{{ $t('cancel')
                }}</button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import item_cart from "../components/cart_item.vue";
export default {
  components: { item_cart },
  data: function () {
    return {
      items: [],
      products: [],
      loading: false,
      show: false,
      price: 0,
    };
  },
  created() {
    let AllCookies = this.$cookies.keys();
    this.products = [];

    for (let i = 0; i < AllCookies.length; i++) {
      if (AllCookies[i].split("/")[0] == this.$store.storeName) {
        this.items.push(AllCookies[i]);
        this.products.push(this.$cookies.get(AllCookies[i]));

        if (this.$cookies.get(AllCookies[i]).offer_price != 0) {
          this.price += this.$cookies.get(AllCookies[i]).offer_price;
        } else {
          this.price += this.$cookies.get(AllCookies[i]).total_price;
        }
        //console.log(this.items);
      }
    }
    console.log(this.items);

    //console.log(this.items[0])
    /* this.$cookies.isKey(
          this.$store.storeName +
            product.product_id +
            product.final_option +
            product.option_check
        )*/

    if (this.$i18n.locale == 'ar') {
      document.title = this.$store.state.title_ar;
      document.getElementById("description_meta").content = this.$store.state.description_ar;
      document.getElementById("keywords_meta").content = this.$store.state.keyword_ar;
    }
    else {
      document.title = this.$store.state.title_en;
      document.getElementById("description_meta").content = this.$store.state.description_en;
      document.getElementById("keywords_meta").content = this.$store.state.keyword_en;
    }
  },
  methods: {
    updateProducts() {
      console.log("hiiiiiiiiiiiiiii");
      this.items = [];
      this.products = [];
      this.price = 0;
      let AllCookies = this.$cookies.keys();
      for (let i = 0; i < AllCookies.length; i++) {
        if (AllCookies[i].split("/")[0] == this.$store.storeName) {
          this.items.push(AllCookies[i]);
          this.products.push(this.$cookies.get(AllCookies[i]));

          if (this.$cookies.get(AllCookies[i]).offer_price != 0) {
            this.price += this.$cookies.get(AllCookies[i]).offer_price;
          } else {
            this.price += this.$cookies.get(AllCookies[i]).total_price;
          }
          //console.log(this.items);
        }
      }
    },
    updatedata() {
      this.loading = true;
      this.items = [];
      this.products = [];
      this.price = 0;
      let AllCookies = this.$cookies.keys();
      for (let i = 0; i < AllCookies.length; i++) {
        if (AllCookies[i].split("/")[0] == this.$store.storeName) {
          this.items.push(AllCookies[i]);
          this.products.push(this.$cookies.get(AllCookies[i]));

          if (this.$cookies.get(AllCookies[i]).offer_price != 0) {
            this.price += this.$cookies.get(AllCookies[i]).offer_price;
          } else {
            this.price += this.$cookies.get(AllCookies[i]).total_price;
          }
          //console.log(this.items);
        }
      }
      this.$store.state.langchange = false;
      setTimeout(() => {
        // this.updateall();
        this.loading = false;
      }, 0.1);
    },
    deleteAllCookies() {
      this.loading = true;
      for (let i = 0; i < this.items.length; i++) {
        this.$cookies.remove(this.items[i]);
      }
      this.items = [];

      console.log("hiiiiiiii" + this.$cookies.keys());
      this.$store.state.cartCounter = 0;
      this.loading = false;
      this.show = false;
    },
    confirmOrder() {
      this.axios
        .post(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/check_all_item_card",
          {
            products: this.products,
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization:
                "Bearer " + this.$localStorage.get(this.$store.storeName),
            },
          }
        )
        .then((response) => {
          if (response.data.code == "1") {
            this.$router.push({
              name: "confirmOrder",
              params: { storeName: this.$store.storeName, lang: this.$i18n.locale },
            });
          } else {
            alert(response.data.message);
            // this.couponMsg = response.data.message;
          }
          //this.addresses = response.data.data.addresses.addresses;
          // console.log(this.addresses);
        })
        .catch((error) => {
          if (error.response.status == "401") {
            this.$localStorage.remove(this.$store.storeName);
            window.location.href = "/";
          }
        });
    },
    confirmOrder_guest() {
      this.axios
        .post(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/check_all_item_card",
          {
            products: this.products,
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization:
                "Bearer " + this.$localStorage.get(this.$store.storeName),
            },
          }
        )
        .then((response) => {
          if (response.data.code == "1") {
            this.$router.push({
              name: "guest_confirmOrder",
              params: { storeName: this.$store.storeName, lang: this.$i18n.locale },
            });
          } else {
            alert(response.data.message);
            // this.couponMsg = response.data.message;
          }
          //this.addresses = response.data.data.addresses.addresses;
          // console.log(this.addresses);
        })
        .catch((error) => {
          if (error.response.status == "401") {
            this.$localStorage.remove(this.$store.storeName);
            window.location.href = "/";
          }
        });
    },
    login() {
      this.$router.push({
        name: "login",
        params: { storeName: this.$store.storeName, lang: this.$i18n.locale },
      });
    }
  },
};
</script>